import { makeStyles } from '@material-ui/core';

export const useTextDetailStyles = makeStyles({
  typography: {
    fontSize: 16,
    fontWeight: 500,
  },
});

export const useOverflowTooltipStyles = makeStyles({
  tooltipPlacement: {
    marginBottom: 2,
  },
});
